import React, { Component } from 'react';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import Footer from './components/layout/Footer';
import Header from './components/layout/Header';
import AuthHeader from './components/layout/AuthHeader';
import InfluencerLanding from './components/home/ForInfluencers';
import CompanyLanding from './components/home/ForCompanies';
import TermsOfService from './components/home/TermsOfService';
import PrivacyPolicy from './components/home/PrivacyPolicy';
import About from './components/home/About';
import SignIn from './components/auth/SignIn';
import CompanySignUp from './components/sign-up/company/CompanySignUp';
import InfluencerSignUp from './components/sign-up/influencer/InfluencerSignUp';
import Home from './components/home/Home';
import SignupModal from './components/shared/signUpModal/SignupModal';
import SubscribeModal from './components/shared/subscribeModal/subscribeModal';
import enhance from './App.enhancer';
import './App.css';
import Dashboard from './components/dashboard/Dashboard';
import MessagePage from './components/messaging/MessagePage';
import SideNav from './components/layout/SideNav';
import Payment from './components/payments/Payment';
import CreateCampaign from './components/company/campaign/CreateCampaign';
import Discover from './components/influencer/Discover';
import DiscoverInfluencers from './components/company/discover-influencers/DiscoverInfluncers';
import Campaign from './components/campaign/Campaign';
import Notification from './components/shared/components/Notification';
import CompanyMatchFeed from './components/company/match-feed/CompanyMatchFeed';
import InfluencerMatchFeed from './components/influencer/match-feed/InfluencerMatchFeed';
import Deals from './components/deals/Deals';
import CompleteDealForm from './components/deals/complete-deal-form/CompleteDealForm';
import ReviewContent from './components/deals/content-review/ReviewContent';
import { ThemeProvider } from '@material-ui/styles';
import Profile from './components/profile/Profile';
import MyCampaigns from './components/company/my-campaigns/MyCampaigns';
import InfluencerSettings from './components/influencer/settings/InfluencerSettings';
import CompanySettings from './components/company/settings/CompanySettings';
import queryString from 'query-string';
import CircularProgress from '@material-ui/core/CircularProgress';
import ScrollToTop from './ScrollToTop';
import CampaignAnalytics from './components/campaign/CampaignAnalytics';
import MetaTags from 'react-meta-tags';
import Landing from "./components/home/Landing";
import LandingB from "./components/home/LandingB";
import LandingA from "./components/home/LandingA";

class App extends Component {
  constructor() {
    super();
    this.state = {
      currentPath: null
    };
  }
  handleOpenSubscribeModal = e => {
    e.preventDefault();
    this.props.openSubscribeModal();
  };

  scrollUp = () => {};

  handleNavChange = newPath => {
    this.setState({
      currentPath: newPath
    });
  };

  render() {
    const {
      auth,
      profile,
      dealList,
      campaignList,
      theme,
      escrowReleaseIsProcessing,
      classes,
      notifications
    } = this.props;

    const notifs = parseFloat(
      notifications ? notifications.filter(not => !not.read).length : 0
    );
    const unreadMessages = parseFloat(
      profile.unReadMessages ? profile.unReadMessages : 0
    );

    const tabNotifications = notifs + unreadMessages;

    return (
      <ThemeProvider theme={theme}>
        <MetaTags>
          <title>{`${
            tabNotifications ? '(' + tabNotifications + ') ' : ''
          }Hypepilot`}</title>
        </MetaTags>
        {profile.isLoaded && (
          <BrowserRouter>
            <ScrollToTop handleNavChange={this.handleNavChange}>
              <div>
                {/* {!auth.uid && (
                <div className="announcement-container">
                  <div className="banner-content">
                    <span class="lauching-soon">Launching soon!</span>
                    <span class="first-to-find-out">
                      {' '}
                      Want to be first to hear about new updates?
                    </span>
                    <button
                      className="btn subscribe-button"
                      onClick={this.handleOpenSubscribeModal}
                    >
                      Subscribe
                    </button>
                  </div>
                </div>
              )} */}
                <Notification />
                <CompleteDealForm />
                <ReviewContent />
                {/* add logic to switch header if user is logged in */}
                {/* {!auth.uid && <Header />} */}
                {auth.uid && <AuthHeader scrollUp={this.scrollUp} />}
                <SubscribeModal />
                <SignupModal />
                <div className="main-content-container">
                  {auth.uid && profile.isLoaded && (
                    <SideNav
                      isCompany={profile.isCompany}
                      currentPath={this.state.currentPath}
                    />
                  )}
                  <Switch>
                    {/* Home */}
                    <Route
                      exact
                      path="/"
                      render={() =>
                        !auth.uid ? <Home /> : <Redirect to="/dashboard" />
                      }
                    />
                    {/* For Influencers */}
                    <Route
                      path="/for-influencers"
                      render={() =>
                        !auth.uid ? (
                          <InfluencerLanding />
                        ) : (
                          <Redirect to="/dashboard" />
                        )
                      }
                    />

                    {/* Landing - Generic */}
                    <Route
                        path="/landing"
                        render={() => <Landing />}
                    />
                    {/* Landing - business A */}
                    <Route
                        path="/landing1"
                        render={() => <LandingA />}
                    />
                    {/* Landing - business B */}
                    <Route
                        path="/landing2"
                        render={() => <LandingB />}
                    />

                    {/* Privacy Policy */}
                    <Route
                      path="/privacy-policy"
                      render={() => <PrivacyPolicy />}
                    />

                    {/* Privacy Policy */}
                    <Route
                      path="/terms-of-service"
                      render={() => <TermsOfService />}
                    />

                    {/* For Companies */}
                    <Route
                      path="/for-companies"
                      render={() =>
                        !auth.uid ? (
                          <CompanyLanding />
                        ) : (
                          <Redirect to="/dashboard" />
                        )
                      }
                    />
                    {/* Sign in  */}
                    <Route
                      path="/signin"
                      render={() =>
                        !auth.uid || !profile.isLoaded ? (
                          <SignIn />
                        ) : (
                          <Redirect to="/dashboard" />
                        )
                      }
                    />
                    {/* Company sign up */}
                    <Route
                      path="/company-signup"
                      render={() =>
                        auth && auth.uid ? (
                          <CompanySignUp />
                        ) : (
                          <Redirect to="/signin" />
                        )
                      }
                    />
                    {/* Influencer sign up */}
                    <Route
                      path="/influencer-signup"
                      render={() => {
                        if (auth && auth.uid) {
                          if (
                            profile.isLoaded &&
                            (profile.signUpComplete ||
                              profile.signUpComplete === undefined)
                          ) {
                            return <Dashboard campaignList={campaignList} />;
                          } else {
                            return <InfluencerSignUp />;
                          }
                        } else {
                          return <Redirect to="/signin" />;
                        }
                      }}
                    />

                    {/* <Route
                      path="/dashboard"
                      render={() => {
                        if (auth && auth.uid) {
                          if (
                            profile.isLoaded &&
                            (profile.signUpComplete ||
                              profile.signUpComplete === undefined)
                          ) {
                            return <Dashboard campaignList={campaignList} />;
                          } else {
                            if (profile.isLoaded && profile.isCompany) {
                              return <Redirect to="/company-signup" />;
                            } else if (profile.isLoaded && !profile.isCompany) {
                              return <Redirect to="/influencer-signup" />;
                            } else {
                              <Redirect to="/signin" />;
                            }
                          }
                        } else {
                          return <Redirect to="/signin" />;
                        }
                      }}
                    /> */}

                    {/* Messaging */}
                    <Route
                      path="/messages"
                      render={() =>
                        auth && auth.uid ? (
                          <MessagePage />
                        ) : (
                          <Redirect to="/signin" />
                        )
                      }
                    />

                    {/* Dashboard */}
                    <Route
                      path="/dashboard"
                      render={() => {
                        if (auth && auth.uid) {
                          if (
                            profile.isLoaded &&
                            (profile.signUpComplete ||
                              profile.signUpComplete === undefined)
                          ) {
                            return <Dashboard campaignList={campaignList} />;
                          } else {
                            if (profile.isLoaded && profile.isCompany) {
                              return <Redirect to="/company-signup" />;
                            } else if (profile.isLoaded && !profile.isCompany) {
                              return <Redirect to="/influencer-signup" />;
                            } else {
                              <Redirect to="/signin" />;
                            }
                          }
                        } else {
                          return <Redirect to="/signin" />;
                        }
                      }}
                    />

                    {/* Create new Campaign */}
                    <Route
                      exact
                      path="/campaign/new"
                      render={props => {
                        if (auth && auth.uid) {
                          if (profile && profile.isCompany) {
                            return <CreateCampaign />;
                          } else {
                            return <Dashboard />;
                          }
                        } else {
                          return <Redirect to="/signin" />;
                        }
                      }}
                    />

                    {/* Discover new campaigns */}
                    <Route
                      path="/discover"
                      render={() =>
                        auth && auth.uid && profile && !profile.isCompany ? (
                          <Discover />
                        ) : (
                          <Redirect to="/dashboard" />
                        )
                      }
                    />

                    {/* View individual campaign */}
                    <Route
                      path="/campaigns/:id"
                      exact
                      render={props =>
                        auth && auth.uid && profile ? (
                          <Campaign page={1} key={props.match.params.id} />
                        ) : (
                          <Redirect to="/dashboard" />
                        )
                      }
                    />

                    <Route
                      path="/campaigns/:id/view"
                      render={props =>
                        auth && auth.uid && profile ? (
                          <Campaign page={1} key={props.match.params.id} />
                        ) : (
                          <Redirect to="/dashboard" />
                        )
                      }
                    />

                    <Route
                      path="/campaigns/:id/invite"
                      render={props =>
                        auth && auth.uid && profile ? (
                          <Campaign page={2} key={props.match.params.id} />
                        ) : (
                          <Redirect to="/dashboard" />
                        )
                      }
                    />

                    <Route
                      path="/campaigns/:id/proposals"
                      render={props =>
                        auth && auth.uid && profile ? (
                          <Campaign page={3} key={props.match.params.id} />
                        ) : (
                          <Redirect to="/dashboard" />
                        )
                      }
                    />

                    <Route
                      path="/campaigns/:id/shortlisted"
                      render={props =>
                        auth && auth.uid && profile ? (
                          <Campaign page={4} key={props.match.params.id} />
                        ) : (
                          <Redirect to="/dashboard" />
                        )
                      }
                    />

                    <Route
                      path="/campaigns/:id/messaged"
                      render={props =>
                        auth && auth.uid && profile ? (
                          <Campaign page={5} key={props.match.params.id} />
                        ) : (
                          <Redirect to="/dashboard" />
                        )
                      }
                    />

                    <Route
                      path="/campaigns/:id/pendingEscrow"
                      render={props =>
                        auth && auth.uid && profile ? (
                          <Campaign page={6} key={props.match.params.id} />
                        ) : (
                          <Redirect to="/dashboard" />
                        )
                      }
                    />

                    <Route
                      path="/campaigns/:id/active"
                      render={props =>
                        auth && auth.uid && profile ? (
                          <Campaign page={7} key={props.match.params.id} />
                        ) : (
                          <Redirect to="/dashboard" />
                        )
                      }
                    />

                    <Route
                      path="/campaigns/:id/contentComplete"
                      render={props =>
                        auth && auth.uid && profile ? (
                          <Campaign page={8} key={props.match.params.id} />
                        ) : (
                          <Redirect to="/dashboard" />
                        )
                      }
                    />

                    <Route
                      path="/campaigns/:id/completed"
                      render={props =>
                        auth && auth.uid && profile ? (
                          <Campaign page={9} key={props.match.params.id} />
                        ) : (
                          <Redirect to="/dashboard" />
                        )
                      }
                    />

                    <Route
                      path="/campaigns/:id/analytics"
                      render={props => {
                        if (auth && auth.uid && profile) {
                          const campaignId = props.match.params.id;

                          return <CampaignAnalytics campaignId={campaignId} />;
                        } else {
                          return <Redirect to="/dashboard" />;
                        }
                      }}
                    />

                    {/* Match Feed */}
                    <Route
                      path="/matchFeed"
                      render={() => {
                        if (auth && auth.uid) {
                          if (profile && profile.isCompany) {
                            return <CompanyMatchFeed />;
                          } else {
                            // change this to influencer match feed eventually
                            return <InfluencerMatchFeed />;
                          }
                        } else {
                          return <Redirect to="/signin" />;
                        }
                      }}
                    />

                    {/* Deals View */}
                    <Route
                      path="/deals"
                      render={() => {
                        if (auth && auth.uid) {
                          return <Deals />;
                        } else {
                          return <Redirect to="/signin" />;
                        }
                      }}
                    />

                    {/* Profiles */}
                    <Route
                      path="/user/:uid/profile"
                      render={props => {
                        const userId = props.match.params.uid;
                        if (auth && auth.uid) {
                          return <Profile userId={userId} />;
                        } else {
                          return <Redirect to="/signin" />;
                        }
                      }}
                    />

                    {/* My Campaigns */}
                    <Route
                      path="/campaigns"
                      exact
                      render={props => {
                        if (auth && auth.uid) {
                          if (profile && profile.isCompany) {
                            return <MyCampaigns />;
                          } else {
                            return <Dashboard />;
                          }
                        } else {
                          return <Redirect to="/signin" />;
                        }
                      }}
                    />

                    {/* Discover Influencers */}
                    <Route
                      path="/discover-influencers"
                      render={props => {
                        if (auth && auth.uid) {
                          if (profile && profile.isCompany) {
                            return <DiscoverInfluencers />;
                          } else {
                            return <Dashboard />;
                          }
                        } else {
                          return <Redirect to="/signin" />;
                        }
                      }}
                    />

                    {/* Settings */}
                    <Route
                      path="/settings"
                      render={props => {
                        if (auth && auth.uid) {
                          if (profile && !profile.isCompany) {
                            let values;
                            if (props.location.search) {
                              values = queryString.parse(props.location.search);
                            }
                            return (
                              <InfluencerSettings
                                paypalResponseValue={values}
                              />
                            );
                          } else if (profile.isLoaded && profile.isCompany) {
                            return <CompanySettings />;
                          }
                        } else {
                          return <Redirect to="/signin" />;
                        }
                      }}
                    />
                  </Switch>
                </div>
                {!auth.uid && <Footer />}
              </div>
            </ScrollToTop>
          </BrowserRouter>
        )}
      </ThemeProvider>
    );
  }
}

App.propTypes = {
  auth: PropTypes.object,
  openSubscribeModal: PropTypes.func,
  profile: PropTypes.object
};

export default enhance(App);



// WEBPACK FOOTER //
// ./src/App.js